import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos M.',
    prof: 'CEO de agencia digital',
    age: 42,
    quote: 'Después de 14 días, mi equipo me preguntó si había dormido 12 horas. La realidad es que dormí las mismas 7, pero por primera vez en años, fue sueño REAL. La app hace que sea imposible olvidar el protocolo.'
  }, {
    name: 'Andrea R.',
    prof: 'Directora de Operaciones',
    age: 38,
    quote: 'Eliminé el crash de las 3 PM en 5 DÍAS. Cinco. Ahora mi tarde es tan productiva como mi mañana. Y la ducha fría se convirtió en mi meditación favorita. Suena loco, pero funciona.'
  }, {
    name: 'Miguel T.',
    prof: 'Fund Manager',
    age: 47,
    quote: 'He comprado 3 libros de biohacking antes. Los leí, los olvidé. Bio-X 90 es diferente porque la app no te DEJA olvidar. Abro la checklist cada mañana como abro el email. Ya llevo 23 días seguidos.'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt" data-id="element-705">
      <div className="max-w-[1000px] mx-auto" data-id="element-706">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-707">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-708">
            Lo Que Dicen los Primeros Ejecutivos Bio-X
          </h2>
          <p className="text-xl text-brand-muted" data-id="element-709">
            Resultados reales de personas reales
          </p>
        </motion.div>

        <div className="flex overflow-x-auto hide-scrollbar snap-x snap-mandatory gap-6 pb-8 -mx-6 px-6 md:grid md:grid-cols-3 md:overflow-visible md:snap-none md:mx-0 md:px-0" data-id="element-710">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="snap-center shrink-0 w-[85vw] md:w-auto bg-brand-card rounded-2xl p-6 md:p-8 border border-brand-border flex flex-col h-full" data-id="element-711">
              <div className="flex gap-1 mb-6" data-id="element-712">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-713" />)}
              </div>

              <p className="text-white italic text-lg leading-relaxed mb-8 flex-grow" data-id="element-714">
                "{t.quote}"
              </p>

              <div className="h-px w-full bg-brand-border mb-6" data-id="element-715" />

              <div className="flex items-center gap-4" data-id="element-716">
                <div className="w-12 h-12 rounded-full bg-brand-cyan/20 flex items-center justify-center text-brand-cyan font-bold text-lg" data-id="element-717">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-718">
                  <p className="font-bold text-white" data-id="element-719">{t.name}</p>
                  <p className="text-brand-muted text-sm" data-id="element-720">
                    {t.prof}, {t.age} años
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}